export default __webpack_public_path__ + "static/media/card-sample.1de0ac57.png";